export default __webpack_public_path__ + "static/media/report-error.9a9ecb6c.svg";